// Task 6: renter-driver vocabulary. Every state is text, never colour alone,
// and never a score or percentage.

export const DRIVER_STATE_LABEL = {
  INVITED: "Invitation sent",
  INFORMATION_REQUIRED: "Information required",
  EVIDENCE_REQUIRED: "Licence photo required",
  SUBMITTED: "Submitted",
  BUSINESS_REVIEW_REQUIRED: "Licence review needed",
  REVIEW_REQUIRED: "Review required",
  ELIGIBLE: "Eligible",
  ELIGIBLE_PENDING_ORIGINAL_CHECK: "Eligible — original licence checked at pickup",
  ELIGIBLE_WITH_POLICY_WARNING: "Eligible (policy exception)",
  INELIGIBLE: "Ineligible",
  EXPIRED: "Expired",
  REMOVED: "Removed",
  SUPERSEDED: "Replaced",
};

export const BOOKING_DRIVER_LABEL = {
  NOT_APPLICABLE: "Not applicable (driver supplied)",
  DRIVER_INFO_REQUIRED: "Driver information required",
  DRIVER_EVIDENCE_REQUIRED: "Driver evidence required",
  DRIVER_UNDER_REVIEW: "Driver under review",
  DRIVER_REVIEW_REQUIRED: "Driver review required",
  DRIVER_ELIGIBLE: "Driver eligible",
  DRIVER_INELIGIBLE: "Driver ineligible",
  ADDITIONAL_DRIVER_ACTION_REQUIRED: "Additional driver action required",
};

export const RELEASE_LABEL = {
  READY: "Ready for self-drive release",
  ORIGINAL_DOCUMENT_CHECK_REQUIRED: "Original document check required",
  EVIDENCE_REVIEW_REQUIRED: "Review required before release",
  BLOCKED: "Release blocked",
  NOT_APPLICABLE: "Not applicable",
};

export const LAYER_LABEL = { LEGAL: "Legal", BUSINESS_POLICY: "Business policy", INSURANCE: "Insurance" };
export const LAYER_STATUS_LABEL = { PASS: "Pass", FAIL: "Fail", REVIEW: "Review", INFORMATION_REQUIRED: "Information required" };
export const SOURCE_LABEL = {
  BUSINESS_POLICY: "Rental business policy",
  INSURER_REQUIREMENT: "Insurer requirement",
  LEGAL_REQUIREMENT: "Legal requirement",
};

export function tone(state) {
  if (["ELIGIBLE", "DRIVER_ELIGIBLE", "READY", "PASS"].includes(state)) return "bg-emerald-50 text-emerald-800 border-emerald-200";
  if (["INELIGIBLE", "DRIVER_INELIGIBLE", "BLOCKED", "FAIL"].includes(state)) return "bg-rose-50 text-rose-800 border-rose-200";
  if (["REMOVED", "SUPERSEDED", "NOT_APPLICABLE"].includes(state)) return "bg-slate-50 text-slate-600 border-slate-200";
  return "bg-amber-50 text-amber-900 border-amber-200";
}

export function humanize(code) {
  if (!code) return "";
  const t = String(code).toLowerCase().replace(/_/g, " ");
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export function errorMessage(err, fallback = "Something went wrong.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.message || fallback;
}

export function pesos(centavos) {
  if (centavos === null || centavos === undefined) return null;
  const whole = Math.trunc(centavos / 100);
  return `₱${whole.toLocaleString("en-PH")}.${String(Math.abs(centavos % 100)).padStart(2, "0")}`;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(",")[1]);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export const PH_CODES = ["A", "A1", "B", "B1", "B2", "C", "D", "BE", "CE"];
